import React from "react";

const NTFooter = () => {
  return (
    <footer>
      <div
        style={{
          display: "flex",
          width: "100%",
          bottom: "0rem",
          position: "static",
          paddingTop: "0px",
        }}
      >
        <div className="container">
          <div
            style={{
              padding: "1rem",
              display: "flex",
              flexWrap: "wrap",
              marginRight: "-15px",
              marginLeft: "-15px",
            }}
          >
            <a
              className="px-2"
              href="https://depws.nt.gov.au/onshore-gas/sreba"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#454347",
                zIndex: 5,
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                textDecoration: "none",
              }}
            >
              SREBA homepage
            </a>
            <p
              className="px-2"
              style={{
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                margin: 0,
              }}
            >
              |
            </p>
            <a
              className="px-2"
              href="https://depws.nt.gov.au/onshore-gas/sreba/information-data/how-to-use-the-sreba-data-calalogue"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#454347",
                zIndex: 5,
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                textDecoration: "none",
              }}
            >
              Help
            </a>
            <p
              className="px-2"
              style={{
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                margin: 0,
                textDecoration: "none",
              }}
            >
              |
            </p>
            <a
              className="px-2"
              href="https://depws.nt.gov.au/consultation-publications/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#454347",
                zIndex: 5,
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                textDecoration: "none",
              }}
            >
              Copyright, disclaimer and privacy
            </a>
            <p
              className="px-2"
              style={{
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                margin: 0,
                textDecoration: "none",
              }}
            >
              |
            </p>
            <a
              className="px-2"
              href="https://nt.gov.au/law/rights/freedom-of-information"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#454347",
                zIndex: 5,
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                textDecoration: "none",
              }}
            >
              Freedom of information
            </a>

            <p
              className="px-2"
              style={{
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                margin: 0,
              }}
            >
              |
            </p>
            <a
              className="px-2"
              href="https://nt.gov.au/page/accessibility"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#454347",
                zIndex: 5,
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                textDecoration: "none",
              }}
            >
              Accessibility
            </a>

            <p
              className="px-2"
              style={{
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                margin: 0,
              }}
            >
              |
            </p>
            <a
              className="px-2"
              href="https://depws.nt.gov.au/contact"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#454347",
                zIndex: 5,
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                textDecoration: "none",
              }}
            >
              Contacts
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NTFooter;
